/*eslint-disable*/
import React from "react";
export default function Footer() {
  return (
    <div className="absolute bottom-0 mx-auto mb-2 lg:mb-6">
      <p className="text-center text-sm text-gray-600 md:text-base lg:mb-0">
        ©{new Date().getFullYear()} BiaFit. All Rights Reserved.
      </p>
    </div>
  );
}
